<template>
  <div
    v-if="m_preloadSdk"
    :class="{ 'container-iframe': true, hide: !m_isIframeSdkVisible }"
  >
    <iframe
      id="XpressID-iframe"
      :src="valueIframe.urlXpressId"
      sandbox="allow-scripts allow-same-origin"
      allow="camera; microphone; geolocation; gyroscope; accelerometer;"
      title="Verificación de identidad"
      style="width: 100%; height: 100%"
      :style="{
        backgroundColor: veridasConfigData.setup.success.backgroundColor
      }"
    ></iframe>
    <VeridasAnalytics />
  </div>
</template>

<script>
import get from "lodash/get";
import bus from "@/bus";
import {
  GET_VERIDAS_RESULT,
  DO_IS_LOADING
} from "@/config/constants/action-types";
import { ON_ERROR } from "@/config/constants/mutation-types";
import VeridasAnalytics from "./VeridasAnalytics.vue";
import { veridasConfigData } from "../../../api/aso";

export default {
  name: "EmbedVeridas",
  components: {
    VeridasAnalytics
  },
  props: {
    valueIframe: Object
  },
  data() {
    return {
      veridasConfigData: veridasConfigData.configData
    };
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage, false);
  },
  methods: {
    emitirBus(level3, analyticsName) {
      bus.$emit("analytics:event", {
        event: "interaction_link",
        eventData: {
          level2: get(this.currentView, "config.analyticsName", ""),
          level3: level3,
          name: analyticsName
        }
      });
    },
    AppStep(appEvent, applicationStep) {
      bus.$emit("analytics:event", {
        event: "sdk_event",
        eventData: {
          applicationStep,
          appEvent
        }
      });
    },
    receiveMessage(event) {
      // Solo escuchar eventos de xpressid
      const origenes = ["xpressid", "bbvafrances.com", "bbva.com", "localhost"];
      if (event && origenes.some(o => event.origin.includes(o)) === false) {
        return;
      }

      const actions = {
        DocumentCameraVideoPlayStarted: this.handleProcessInitialized,
        DocumentLoaded: this.handleDocumentStarted,
        DocumentObverseDetection: this.handleEventDocumentFront,
        DocumentProcessFinished: this.handleDocumentProcessFinished,
        SelfieLoaded: this.handleAliveProcessStarted,
        SelfieFaceDetection: this.handleEventSelfie,
        ProcessCompleted: this.handleAliveProcessFinished,
        ProcessCancelled: this.handleIframeClose,
        DocumentCloseButtonClicked: this.handleIframeClose,
        Error: this.handleError
      };

      let code;
      if (event.data.type === "error") {
        code = "Error";
      } else if (event.data?.code.includes("ProcessEvents")) {
        code = event.data?.infoEvent?.code;
      } else {
        code = event.data?.code;
      }

      const action = actions[code];
      if (typeof action === "function") {
        action.call(this, event);
      }
    },
    handleError(event) {
      this.handleIframeClose();
      this.$log.error("Error Veridas", event.data.code);
      this.$store.commit(ON_ERROR, event.data);

      if (
        event.data.code === "BlurredImageError" ||
        event.data.code === "UnknownDocumentTypeError" ||
        event.data.code === "ModalErrorClosed"
      ) {
        this.$router.push({
          name: "mensajeVeridas",
          params: {
            mje: "error-dni"
          }
        });
        return;
      }

      //cualquier tipo de falla cae acá
      this.$router.push({
        name: "mensajeVeridas",
        params: {
          mje: "error-servicio-veridas"
        }
      });
    },
    handleIframeClose() {
      this.$store.dispatch(DO_IS_LOADING, false);
      this.$emit("close");
      this.destroySdk();
    },
    handleProcessInitialized() {
      this.$store.dispatch(DO_IS_LOADING, false);
      this.AppStep("app_started", "0 start");
    },
    handleDocumentStarted() {
      this.emitirBus("comenzar", "sacar fotos");
    },
    handleEventDocumentFront() {
      this.AppStep("app_step_2", "2 dni dorso", "fotos dni");
    },
    handleDocumentProcessFinished() {
      this.AppStep("app_step_3", "3 success dni", "success dni");
    },
    handleAliveProcessStarted() {
      this.emitirBus("3 success dni", "sacar selfies", "success dni");
    },
    handleEventSelfie() {
      this.AppStep("app_step_4", "4 selfie", "biometría");
    },
    handleAliveProcessFinished() {
      this.$router.replace(this.config.pasos.loadingVeridas.path);
      this.$store.dispatch(GET_VERIDAS_RESULT);
      this.handleIframeClose();
    }
  },
  destroyed() {
    this.$store.dispatch(DO_IS_LOADING, false);
    window.removeEventListener("message", this.receiveMessage);
    this.destroySdk();
  }
};
</script>

<style scoped>
.hide {
  opacity: 0;
  z-index: -9999 !important;
  pointer-events: none;
}
div.container-iframe {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  z-index: 9999;
}
</style>
